import { useCallback } from 'react';
import { AccordionSection } from '../../../components-bl/EmailMarketing/types';

interface Props {
  sections: AccordionSection[];
  setExpendedSection: (sectionId: string) => void;
}

export const useExpandSelectionChange = ({ sections, setExpendedSection }: Props) => {
  const onExpandSelectionChange = useCallback(
    (expandedIds: string[]): void => {
      const newId = expandedIds?.[0] || null;
      const selectedSection = sections.find(section => section.id === newId);

      if (selectedSection?.isDisabled) {
        return;
      }
      setExpendedSection(newId);
    },
    [setExpendedSection]
  );

  return { onExpandSelectionChange };
};
